<template>
  <div>
    <div>
      <div>
        <b-sidebar
          id="sidebar-cat"
          bg-variant="white"
          v-model="visibility8"
          sidebar-class="sidebar-lg"
          right
          no-header
          backdrop
          shadow
        >
          <div
            class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
          >
            <h5 class="mb-0">
              {{ $t("Left " + classLabel) }} - {{ leftName }}
            </h5>
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="visibility8 = false"
            />
          </div>

          <b-form class="p-2" @submit.prevent>
            <b-row>
              <b-col cols="12" class="mb-1">
                <b-form-group :invalid-feedback="$t('Category is required')">
                  <div class="">
                    <label class="bv-no-focus-ring col-form-label pt-0">
                      {{ $t("Category") }}</label
                    >
                    <feather-icon
                      v-if="canManage"
                      class="cursor-pointer ml-50"
                      icon="EditIcon"
                      size="18"
                      v-b-tooltip.hover.top
                      :title="$t('Manage Categories')"
                      @click="openCat()"
                    />
                  </div>
                  <v-select
                    v-model="leftSelected"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="[{ title: 'None' }, ...leftOptions]"
                    :reduce="(opt) => opt.title"
                    label="title"
                    :clearable="false"
                    :placeholder="$t('Select category')"
                  />
                </b-form-group>
              </b-col>
              <b-col md="12" v-if="isCoaching">
                <b-form-group
                  label="Session"
                  invalid-feedback="Session is required."
                  ref="session"
                >
                  <v-select
                    v-model="leftSessionID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="sessions"
                    :reduce="(opt) => opt.id"
                    label="session"
                    :clearable="false"
                    placeholder="Select session"
                  />
                </b-form-group>
              </b-col>
              <b-col class="mt-1" md="12">
                <b-button
                  type="submit"
                  variant="success"
                  @click="leftNew()"
                  block
                  :disabled="lefting"
                >
                  <b-spinner v-if="lefting" small type="grow" />
                  <span v-else> {{ $t("Left " + classLabel) }}</span>
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-sidebar>

        <b-sidebar
          id="sidebar-cat"
          bg-variant="white"
          v-model="visibility9"
          sidebar-class="sidebar-lg"
          right
          no-header
          backdrop
          shadow
        >
          <div
            class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
          >
            <h5 class="mb-0">{{ $t("Manage Categories") }}</h5>
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="visibility9 = false"
            />
          </div>

          <b-form class="p-2" @submit.prevent>
            <b-row class="d-flex align-items-center">
              <b-col md="12">
                <b-form-group
                  :label="$t('Category Name') + ' *'"
                  :invalid-feedback="$t('Category name is required')"
                >
                  <b-form-input
                    ref="cat_name"
                    v-model.trim="catObj.title"
                    :placeholder="$t('Enter category name')"
                    @focusout="checkCat()"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-button
                  variant="success"
                  class="btn-icon mt-1"
                  @click="saveCat()"
                  :disabled="savingCat"
                  block
                >
                  <b-spinner v-if="savingCat" small type="grow" />
                  <span v-else>{{ $t("Save") }}</span>
                </b-button>
              </b-col>
            </b-row>
            <b-table
              class="mt-2"
              show-empty
              :items="leftOptions"
              :fields="catFields"
              responsive
              hover
            >
              <template #head()="scope">
                <div :class="scope.label == 'actions' && 'text-right'">
                  {{ $t(scope.label) }}
                </div>
              </template>

              <template #cell(actions)="data">
                <div class="text-right">
                  <b-button
                    variant="primary"
                    class="btn-icon mr-50"
                    @click="editCat(data.item)"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                  <!-- <b-button
                  variant="outline-danger"
                  class="btn-icon"
                  @click="deleteCat(data.item.id)"
                >
                  <feather-icon icon="Trash2Icon" />
                </b-button> -->
                </div>
              </template>
            </b-table>
          </b-form>
        </b-sidebar>

        <!-- SideBar For Department -->
        <b-sidebar
          id="sidebar-Department"
          bg-variant="white"
          v-model="visibility1"
          sidebar-class="sidebar-lg"
          right
          no-header
          backdrop
          shadow
        >
          <div
            class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
          >
            <h5 class="mb-0">
              {{ $t(sidebarTitle) }}
            </h5>
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="hideDepSideBar()"
            />
          </div>
          <b-form class="p-2" @submit.prevent>
            <b-row class="mt-1">
              <b-col md="12">
                <b-form-group
                  :label="$t('Department name') + ' *'"
                  :invalid-feedback="$t('Department name is required')"
                >
                  <b-form-input
                    id="mc-first-name"
                    :placeholder="$t('Enter department name')"
                    ref="depname"
                    v-model.trim="depObj.name"
                    @focusout="CheckDepName()"
                  />
                </b-form-group>
              </b-col>
              <b-col md="12" v-if="settObj">
                <b-form-group
                  :label="$t('WhatsApp From') + ' *'"
                  :invalid-feedback="$t('WhatsApp from is required')"
                >
                  <v-select
                    ref="wcampus"
                    v-model="depObj.whatsAppCampusID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="$store.state.branches"
                    :clearable="false"
                    label="branch"
                    :reduce="(val) => val.id"
                    :placeholder="$t('Select')"
                  />
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="success"
                  @click="DepAdd()"
                  :disabled="request"
                  block
                >
                  <b-spinner v-if="request" small type="grow" />
                  <span v-else> {{ $t(sidebarButton) }} </span>
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-sidebar>

        <!-- SideBar For Classes -->
        <b-sidebar
          id="sidebar-right"
          ref="mySidebar"
          bg-variant="white"
          v-model="visibility"
          sidebar-class="sidebar-lg"
          right
          no-header
          backdrop
          shadow
        >
          <div
            class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
          >
            <h5 class="mb-0">
              {{ $t(sidebarTitle) }}
            </h5>
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="hideSideBar()"
            />
          </div>
          <b-form class="p-2" @submit.prevent>
            <b-row>
              <b-col md="12">
                <b-form-group
                  :label="$t('Department') + ' *'"
                  :invalid-feedback="$t('Department is required')"
                  ref="department"
                >
                  <v-select
                    v-model="myObj.cls.departmentID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="this.myDepartments"
                    :clearable="false"
                    ref="status"
                    label="name"
                    :reduce="(val) => val.id"
                    :disabled="dataloading"
                    :placeholder="$t('Select Department')"
                    @input="CheckDepartment()"
                  />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  :label="$t(classLabel + ' name') + ' *'"
                  :invalid-feedback="$t(classLabel + ' is required')"
                >
                  <b-form-input
                    id="mc-first-name"
                    :placeholder="$t('Enter ' + classLabel + ' name')"
                    ref="name"
                    v-model="myObj.cls.name"
                    @input="CheckName()"
                  />
                </b-form-group>
              </b-col>
              <b-col md="12" v-if="selecting">
                <b-form-group
                  :label="$t('Select ' + sectionLabel + 's') + ' *'"
                  :invalid-feedback="$t(sectionLabel + ' is required')"
                  ref="sections"
                >
                  <div
                    style="
                      border: 1px solid lightgray;
                      padding: 5px;
                      border-radius: 5px;
                    "
                  >
                    <b-button
                      v-for="sec in sections"
                      :key="sec.id"
                      :variant="
                        allSectionIDs.includes(sec.id)
                          ? 'primary'
                          : 'outline-primary'
                      "
                      class="btn-icon m-25"
                      @click="selectSection(sec.id)"
                    >
                      {{ sec.section }}
                    </b-button>
                    <!-- <b-badge
                    class="sectionBadge"
                    style=""
                    v-for="sec in sections"
                    :key="sec.id"
                  >
                    {{ sec.section }}
                  </b-badge> -->
                    <b-button
                      @click="addSection()"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      class="btn-icon rounded-circle"
                    >
                      <feather-icon icon="PlusIcon" />
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="12" v-if="!selecting">
                <b-form-group :label="$t('Add new ' + sectionLabel)">
                  <div class="d-flex">
                    <b-form-input
                      :placeholder="$t('Enter ' + sectionLabel + ' name')"
                      v-model.trim="sectionObj.section"
                    />
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-danger"
                      class="btn-icon mr-0 ml-sm-1"
                      @click="HideSection()"
                    >
                      <feather-icon icon="XIcon" />
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="primary"
                      class="btn-icon mr-0 ml-sm-1"
                      :disabled="savingSection"
                      @click="postSection()"
                    >
                      <feather-icon icon="CheckIcon" />
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-form-group
                  :label="$t('Arrival time') + ' *'"
                  :invalid-feedback="$t('Arrival time is required')"
                  ref="arrival"
                >
                  <flat-pickr
                    v-model="myObj.cls.startsAt"
                    class="form-control"
                    :config="{
                      enableTime: true,
                      noCalendar: true,
                      altFormat: 'h:i',
                      altInput: true,
                      dateFormat: 'Y-m-d\\TH:i:S',
                      defaultHour: 13,
                    }"
                    :placeholder="$t('Enter time')"
                  />
                </b-form-group>
              </b-col>

              <b-col md="12" v-if="selecting">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="success"
                  @click="Add()"
                  :disabled="request"
                  block
                >
                  <b-spinner v-if="request" small type="grow" />
                  <span v-else> {{ $t(sidebarButton) }} </span>
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-sidebar>

        <!-- Section Sidebar -->
        <b-sidebar
          id="sidebar-right"
          ref="mySidebar"
          bg-variant="white"
          v-model="secVisibility"
          sidebar-class="sidebar-lg"
          right
          no-header
          backdrop
          shadow
        >
          <div
            class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
          >
            <h5 class="mb-0">
              {{ $t("Assign Sections") }} - {{ myObj.cls.name }}
            </h5>
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="secVisibility = false"
            />
          </div>
          <b-form class="p-2" @submit.prevent>
            <b-row>
              <b-col md="12">
                <b-form-group
                  :label="$t('Select Sections') + ' *'"
                  :invalid-feedback="$t('Sections is required')"
                  ref="sections"
                >
                  <div
                    style="
                      border: 1px solid lightgray;
                      padding: 5px;
                      border-radius: 5px;
                    "
                  >
                    <b-button
                      v-for="sec in sections"
                      :key="sec.id"
                      :variant="
                        allSectionIDs.includes(sec.id)
                          ? 'primary'
                          : 'outline-primary'
                      "
                      class="btn-icon m-25"
                      @click="selectSection(sec.id)"
                    >
                      {{ sec.section }}
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="success"
                  @click="Assign()"
                  :disabled="request"
                  block
                >
                  <b-spinner v-if="request" small type="grow" />
                  <span v-else> {{ $t("Save") }} </span>
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-sidebar>

        <b-sidebar
          id="sidebar-Department"
          bg-variant="white"
          v-model="visibility3"
          sidebar-class="sidebar-lg"
          right
          no-header
          backdrop
          shadow
        >
          <div
            class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
          >
            <h5 class="mb-0">{{ $t("Shift " + classLabel) }}</h5>

            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="visibility3 = false"
            />
          </div>
          <b-form class="p-2" @submit.prevent>
            <b-row class="mt-1">
              <b-table
                :items="shiftData"
                :fields="shiftFields"
                show-empty
                responsive
                hover
              >
                <template #cell(current_class)="data">
                  <!-- style="outline" -->
                  {{ getClassName(data.item.current_class) }}
                  <!-- <v-select
                    v-model="data.item.current_class"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="allClasses"
                    :reduce="(val) => val.id"
                    label="name"
                    :clearable="false"
                    placeholder=""
                    disabled
                  /> -->
                </template>
                <template #cell(move_to)="data">
                  <v-select
                    v-model="data.item.move_to"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="allClasses"
                    :reduce="(val) => val.id"
                    label="name"
                    :clearable="false"
                    placeholder=""
                  />
                </template>
              </b-table>

              <b-col md="12">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  @click="Shift()"
                  :disabled="shifting"
                  block
                >
                  <b-spinner v-if="shifting" small type="grow" />
                  <span v-else> {{ $t("Shift") }} </span>
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-sidebar>

        <b-sidebar
          id="sidebar-Department"
          bg-variant="white"
          v-model="visibility4"
          sidebar-class="sidebar-lg"
          right
          no-header
          backdrop
          shadow
        >
          <div
            class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
          >
            <h5 class="mb-0">{{ $t("Shift " + classLabel) }}</h5>

            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="visibility4 = false"
            />
          </div>
          <b-form class="p-2" @submit.prevent>
            <b-row class="mt-1">
              <b-col md="12">
                <b-form-group
                  :label="$t('From ' + classLabel)"
                  :invalid-feedback="$t(classLabel + ' is required')"
                  ref="from_cls"
                >
                  <v-select
                    v-model="singleObj.clsFrom"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="allClasses"
                    :reduce="(val) => val.id"
                    label="name"
                    :clearable="false"
                    :placeholder="$t('Select ' + classLabel)"
                    @input="fillCurrent()"
                  />
                  <!-- :options="
                      allClasses.filter((el) => el.id != singleObj.clsTo)
                    " -->
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-form-group
                  :label="$t('From ' + sectionLabel)"
                  :invalid-feedback="$t(sectionLabel + ' is required')"
                  ref="from_sec"
                >
                  <v-select
                    v-model="singleObj.secFrom"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="currentSections"
                    :reduce="(val) => val.id"
                    label="section"
                    :clearable="false"
                    :placeholder="$t('Select ' + sectionLabel)"
                    @input="checkSame()"
                  />
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-form-group
                  :label="$t('Move To')"
                  :invalid-feedback="$t(classLabel + ' is required')"
                  ref="move_cls"
                >
                  <v-select
                    v-model="singleObj.clsTo"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="allClasses"
                    :reduce="(val) => val.id"
                    label="name"
                    :clearable="false"
                    :placeholder="$t('Select ' + classLabel)"
                    @input="fillMove()"
                  />
                  <!-- :options="
                      allClasses.filter((el) => el.id != singleObj.clsFrom)
                    " -->
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-form-group
                  :label="$t('Move ' + sectionLabel)"
                  :invalid-feedback="$t(sectionLabel + ' is required')"
                  ref="move_sec"
                >
                  <v-select
                    v-model="singleObj.secTo"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="moveSections"
                    :reduce="(val) => val.id"
                    label="section"
                    :clearable="false"
                    :placeholder="$t('Select ' + sectionLabel)"
                    @input="checkSame()"
                  />
                </b-form-group>
              </b-col>

              <b-col md="12" class="mt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  @click="ShiftSingle()"
                  :disabled="shifting"
                  block
                >
                  <b-spinner v-if="shifting" small type="grow" />
                  <span v-else> {{ $t("Shift") }} </span>
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-sidebar>

        <b-sidebar
          id="sidebar-timing"
          bg-variant="white"
          v-model="visibility5"
          sidebar-class="sidebar-lg"
          right
          no-header
          backdrop
          shadow
          width="500px"
        >
          <div
            class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
          >
            <h5 class="mb-0">
              {{ $t("Department Timings") }}
              <template v-if="stdObj && stdObj.valueBool">
                <b-spinner v-if="syncing" small class="ml-1" />
                <feather-icon
                  v-else
                  class="cursor-pointer ml-1"
                  icon="RefreshCcwIcon"
                  size="16"
                  v-b-tooltip.hover.bottomright
                  :title="$t('Sync student timings')"
                  @click="!savingTime && syncTimings()"
                />
              </template>
              <b-form-checkbox
                class="mr-0 ml-1"
                v-model="sameDays"
                switch
                inline
                v-b-tooltip.hover.bottomright
                :title="$t('Everyday schedule same as monday')"
                @input="setDays(timingInfo[0])"
              />
            </h5>
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="visibility5 = false"
            />
          </div>
          <b-form class="px-1 py-2" @submit.prevent>
            <b-row align-h="center" v-if="timeLoading">
              <b-spinner
                class="my-4"
                style="width: 2.5rem; height: 2.5rem"
                variant="primary"
                type="grow"
                :label="$t('Spinning')"
              ></b-spinner>
            </b-row>
            <template v-else>
              <b-row v-for="(item, index) in timingInfo" :key="index">
                <b-col md="4" class="pr-md-0">
                  <b-form-group
                    :invalid-feedback="$t('Day is required')"
                    ref="day"
                  >
                    <div class="">
                      <label class="bv-no-focus-ring col-form-label pt-0"
                        >{{ $t("Day") }}
                        <b-form-checkbox
                          v-model="item.isActive"
                          switch
                          inline
                          v-b-tooltip.hover.bottomright
                          :title="$t('Active')"
                          class="mr-0 ml-1"
                          size="lg"
                        />
                      </label>
                    </div>

                    <v-select
                      v-model="item.day"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="daysList"
                      :reduce="(op) => op.value"
                      :selectable="(opt) => !currDays.includes(opt.value)"
                      :clearable="false"
                      label="text"
                      @input="changeDay()"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3" class="pr-md-0">
                  <b-form-group
                    :label="$t('Joins at')"
                    :invalid-feedback="$t('Joins at is required')"
                    ref="join"
                  >
                    <flat-pickr
                      v-model="item.timeIn"
                      class="form-control"
                      :config="{
                        enableTime: true,
                        noCalendar: true,
                        altFormat: 'h:i K',
                        altInput: true,
                        dateFormat: 'Y-m-d\\TH:i:S',
                        defaultHour: 8,
                      }"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3" class="pr-md-0">
                  <b-form-group
                    :label="$t('Leaves at')"
                    :invalid-feedback="$t('Leaves at is required')"
                    ref="leave"
                  >
                    <flat-pickr
                      v-model="item.timeOut"
                      class="form-control"
                      :config="{
                        enableTime: true,
                        noCalendar: true,
                        altFormat: 'h:i K',
                        altInput: true,
                        dateFormat: 'Y-m-d\\TH:i:S',
                        defaultHour: 13,
                      }"
                      @on-close="setDays(item)"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="2" class="pr-md-0 align-self-center">
                  <feather-icon
                    v-if="index == timingInfo.length - 1"
                    icon="PlusIcon"
                    size="16"
                    class="cursor-pointer ml-50"
                    @click="addDay()"
                  />
                  <feather-icon
                    v-if="timingInfo.length > 1"
                    icon="TrashIcon"
                    size="16"
                    class="cursor-pointer ml-50"
                    @click="removeDay(item, index)"
                  />
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col md="12">
                  <b-button
                    variant="success"
                    @click="saveTimings()"
                    :disabled="savingTime || syncing"
                    block
                  >
                    <b-spinner v-if="savingTime" small type="grow" />
                    <span v-else> {{ $t("Save") }} </span>
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-form>
        </b-sidebar>

        <b-modal
          id="modal-sections"
          v-model="sectionsModalVisible"
          hide-footer
          centered
          size="lg"
          modal-class="sections-modal-wrapper"
          header-class="sections-modal-header"
          body-class="sections-modal-body"
          content-class="sections-modal-content"
          @hidden="closeSectionsModal"
        >
          <template #modal-title>
            <div class="sections-modal-title">
              <span class="sections-modal-title-icon">
                <feather-icon icon="LayersIcon" size="18" />
              </span>
              <div>
                <h5 class="mb-0">{{ $t("Manage " + sectionLabel + "s") }}</h5>
                <small class="sections-modal-subtitle">
                  {{
                    $t("Add or update " + sectionLabel.toLowerCase() + " names")
                  }}
                </small>
              </div>
            </div>
          </template>

          <div class="sections-modal-add-panel">
            <b-form-input
              :placeholder="$t('Enter ' + sectionLabel + ' name')"
              v-model.trim="sectionObj.section"
              class="sections-modal-input"
              @keyup.enter="postSection()"
            />
            <b-button
              variant="primary"
              class="sections-modal-add-btn"
              :disabled="savingSection"
              @click="postSection()"
            >
              <b-spinner v-if="savingSection" small type="grow" />
              <template v-else>
                <feather-icon icon="PlusIcon" size="16" class="mr-50" />
                {{ $t("Add") }}
              </template>
            </b-button>
          </div>

          <div class="sections-modal-search">
            <feather-icon
              icon="SearchIcon"
              size="16"
              class="sections-modal-search-icon"
            />
            <b-form-input
              v-model="sectionModalSearch"
              :placeholder="$t('Search') + '...'"
              class="sections-modal-input sections-modal-search-input"
            />
          </div>

          <div class="sections-modal-table-wrap">
            <b-table
              :items="filteredModalSections"
              :fields="sectionModalFields"
              :busy="loadingSections"
              show-empty
              responsive
              hover
              small
              class="sections-modal-table"
            >
              <template #empty>
                <h5 class="text-center my-2">{{ $t("No records found") }}</h5>
              </template>
              <template #table-busy>
                <div class="d-flex justify-content-center my-2">
                  <b-spinner variant="primary" />
                </div>
              </template>
              <template #cell(section)="data">
                <b-form-input
                  v-if="editingSectionId === data.item.id"
                  v-model.trim="editingSectionName"
                  @keyup.enter="saveSectionEdit()"
                />
                <span v-else>{{ data.item.section }}</span>
              </template>
              <template #cell(actions)="data">
                <div v-if="editingSectionId === data.item.id" class="d-flex">
                  <b-button
                    size="sm"
                    variant="primary"
                    class="btn-icon mr-50"
                    :disabled="savingSectionEdit"
                    @click="saveSectionEdit()"
                  >
                    <b-spinner v-if="savingSectionEdit" small />
                    <feather-icon v-else icon="CheckIcon" size="16" />
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    class="btn-icon"
                    :disabled="savingSectionEdit"
                    @click="cancelEditSection()"
                  >
                    <feather-icon icon="XIcon" size="16" />
                  </b-button>
                </div>
                <b-button
                  v-else-if="rights.edit && canManage"
                  size="sm"
                  variant="outline-primary"
                  class="btn-icon"
                  @click="startEditSection(data.item)"
                >
                  <feather-icon icon="EditIcon" size="16" />
                </b-button>
              </template>
            </b-table>
          </div>
        </b-modal>

        <b-modal
          id="modal-subjects"
          v-model="subjectsModalVisible"
          hide-footer
          centered
          size="lg"
          modal-class="sections-modal-wrapper"
          header-class="sections-modal-header"
          body-class="sections-modal-body"
          content-class="sections-modal-content"
          @hidden="closeSubjectsModal"
        >
          <template #modal-title>
            <div class="sections-modal-title">
              <span class="sections-modal-title-icon">
                <feather-icon icon="BookOpenIcon" size="18" />
              </span>
              <div>
                <h5 class="mb-0">{{ $t("Manage Subjects") }}</h5>
                <small class="sections-modal-subtitle">
                  {{ $t("Add or update subject names") }}
                </small>
              </div>
            </div>
          </template>

          <div class="sections-modal-add-panel">
            <b-form-input
              :placeholder="$t('Enter subject name')"
              v-model.trim="subjectObj.subject"
              class="sections-modal-input"
              @keyup.enter="postSubject()"
            />
            <b-button
              variant="primary"
              class="sections-modal-add-btn"
              :disabled="savingSubject"
              @click="postSubject()"
            >
              <b-spinner v-if="savingSubject" small type="grow" />
              <template v-else>
                <feather-icon icon="PlusIcon" size="16" class="mr-50" />
                {{ $t("Add") }}
              </template>
            </b-button>
          </div>

          <div class="sections-modal-search">
            <feather-icon
              icon="SearchIcon"
              size="16"
              class="sections-modal-search-icon"
            />
            <b-form-input
              v-model="subjectModalSearch"
              :placeholder="$t('Search') + '...'"
              class="sections-modal-input sections-modal-search-input"
            />
          </div>

          <div class="sections-modal-table-wrap">
            <b-table
              :items="filteredModalSubjects"
              :fields="subjectModalFields"
              :busy="loadingSubjects"
              show-empty
              responsive
              hover
              small
              class="sections-modal-table"
            >
              <template #empty>
                <h5 class="text-center my-2">{{ $t("No records found") }}</h5>
              </template>
              <template #table-busy>
                <div class="d-flex justify-content-center my-2">
                  <b-spinner variant="primary" />
                </div>
              </template>
              <template #cell(subject)="data">
                <b-form-input
                  v-if="editingSubjectId === data.item.id"
                  v-model.trim="editingSubjectName"
                  @keyup.enter="saveSubjectEdit()"
                />
                <span v-else>{{ data.item.subject }}</span>
              </template>
              <template #cell(actions)="data">
                <div v-if="editingSubjectId === data.item.id" class="d-flex">
                  <b-button
                    size="sm"
                    variant="primary"
                    class="btn-icon mr-50"
                    :disabled="savingSubjectEdit"
                    @click="saveSubjectEdit()"
                  >
                    <b-spinner v-if="savingSubjectEdit" small />
                    <feather-icon v-else icon="CheckIcon" size="16" />
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    class="btn-icon"
                    :disabled="savingSubjectEdit"
                    @click="cancelEditSubject()"
                  >
                    <feather-icon icon="XIcon" size="16" />
                  </b-button>
                </div>
                <b-button
                  v-else-if="rights.edit && canManage"
                  size="sm"
                  variant="outline-primary"
                  class="btn-icon"
                  @click="startEditSubject(data.item)"
                >
                  <feather-icon icon="EditIcon" size="16" />
                </b-button>
              </template>
            </b-table>
          </div>
        </b-modal>

        <b-modal
          id="modal-happiness-dropdown"
          v-model="dropdownModalVisible"
          hide-footer
          centered
          size="lg"
          modal-class="sections-modal-wrapper"
          header-class="sections-modal-header"
          body-class="sections-modal-body"
          content-class="sections-modal-content"
          @hidden="closeDropdownModal"
        >
          <template #modal-title>
            <div class="sections-modal-title">
              <span class="sections-modal-title-icon">
                <feather-icon icon="ListIcon" size="18" />
              </span>
              <div>
                <h5 class="mb-0">{{ dropdownModalTitle }}</h5>
                <small class="sections-modal-subtitle">
                  {{ $t("Add or update items") }}
                </small>
              </div>
            </div>
          </template>

          <div class="sections-modal-add-panel">
            <b-form-input
              :placeholder="$t('Enter name')"
              v-model.trim="dropdownFormTitle"
              class="sections-modal-input"
              @keyup.enter="saveDropdownItem()"
            />
            <b-button
              variant="primary"
              class="sections-modal-add-btn"
              :disabled="dropdownSaving"
              @click="saveDropdownItem()"
            >
              <b-spinner
                v-if="dropdownSaving && !dropdownEditingId"
                small
                type="grow"
              />
              <template v-else>
                <feather-icon icon="PlusIcon" size="16" class="mr-50" />
                {{ $t("Add") }}
              </template>
            </b-button>
          </div>

          <div class="sections-modal-search">
            <feather-icon
              icon="SearchIcon"
              size="16"
              class="sections-modal-search-icon"
            />
            <b-form-input
              v-model="dropdownModalSearch"
              :placeholder="$t('Search') + '...'"
              class="sections-modal-input sections-modal-search-input"
            />
          </div>

          <div class="sections-modal-table-wrap">
            <b-table
              :items="filteredDropdownModalItems"
              :fields="dropdownModalFields"
              :busy="dropdownLoading"
              show-empty
              responsive
              hover
              small
              class="sections-modal-table"
            >
              <template #empty>
                <h5 class="text-center my-2">{{ $t("No records found") }}</h5>
              </template>
              <template #table-busy>
                <div class="d-flex justify-content-center my-2">
                  <b-spinner variant="primary" />
                </div>
              </template>
              <template #cell(title)="data">
                <b-form-input
                  v-if="dropdownEditingId === data.item.id"
                  v-model.trim="dropdownEditingTitle"
                  @keyup.enter="saveDropdownEdit()"
                />
                <span v-else>{{ data.item.title }}</span>
              </template>
              <template #cell(actions)="data">
                <div v-if="dropdownEditingId === data.item.id" class="d-flex">
                  <b-button
                    size="sm"
                    variant="primary"
                    class="btn-icon mr-50"
                    :disabled="dropdownSaving"
                    @click="saveDropdownEdit()"
                  >
                    <b-spinner v-if="dropdownSaving" small />
                    <feather-icon v-else icon="CheckIcon" size="16" />
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    class="btn-icon"
                    :disabled="dropdownSaving"
                    @click="cancelEditDropdownItem()"
                  >
                    <feather-icon icon="XIcon" size="16" />
                  </b-button>
                </div>
                <b-button
                  v-else-if="rights.edit && canManage"
                  size="sm"
                  variant="outline-primary"
                  class="btn-icon"
                  @click="startEditDropdownItem(data.item)"
                >
                  <feather-icon icon="EditIcon" size="16" />
                </b-button>
              </template>
            </b-table>
          </div>
        </b-modal>

        <b-modal
          id="modal-sessions-manage"
          v-model="sessionsModalManageVisible"
          hide-footer
          centered
          size="lg"
          modal-class="sections-modal-wrapper"
          header-class="sections-modal-header"
          body-class="sections-modal-body"
          content-class="sections-modal-content"
          @hidden="closeSessionsManageModal"
        >
          <template #modal-title>
            <div class="sections-modal-title">
              <span class="sections-modal-title-icon">
                <feather-icon icon="CalendarIcon" size="18" />
              </span>
              <div>
                <h5 class="mb-0">{{ $t("Manage " + sessionLabel + "s") }}</h5>
                <small class="sections-modal-subtitle">
                  {{
                    $t("Add or update " + sessionLabel.toLowerCase() + " names")
                  }}
                </small>
              </div>
            </div>
          </template>

          <div class="sections-modal-add-panel">
            <b-form-input
              :placeholder="$t('Enter ' + sessionLabel.toLowerCase() + ' name')"
              v-model.trim="sessionManageObj.session"
              class="sections-modal-input"
              @keyup.enter="postSessionManage()"
            />
            <b-button
              variant="primary"
              class="sections-modal-add-btn"
              :disabled="savingSessionManage"
              @click="postSessionManage()"
            >
              <b-spinner v-if="savingSessionManage" small type="grow" />
              <template v-else>
                <feather-icon icon="PlusIcon" size="16" class="mr-50" />
                {{ $t("Add") }}
              </template>
            </b-button>
          </div>

          <div class="sections-modal-search">
            <feather-icon
              icon="SearchIcon"
              size="16"
              class="sections-modal-search-icon"
            />
            <b-form-input
              v-model="sessionModalSearch"
              :placeholder="$t('Search') + '...'"
              class="sections-modal-input sections-modal-search-input"
            />
          </div>

          <div class="sections-modal-table-wrap">
            <b-table
              :items="filteredModalSessions"
              :fields="sessionModalFields"
              :busy="loadingSessionsList"
              show-empty
              responsive
              hover
              small
              class="sections-modal-table"
            >
              <template #empty>
                <h5 class="text-center my-2">{{ $t("No records found") }}</h5>
              </template>
              <template #table-busy>
                <div class="d-flex justify-content-center my-2">
                  <b-spinner variant="primary" />
                </div>
              </template>
              <template #cell(session)="data">
                <b-form-input
                  v-if="editingSessionManageId === data.item.id"
                  v-model.trim="editingSessionManageName"
                  @keyup.enter="saveSessionManageEdit()"
                />
                <span v-else>{{ data.item.session }}</span>
                <b-badge
                  v-if="
                    (data.item.status || '').toLowerCase() === 'active' &&
                    !editingSessionManageId
                  "
                  variant="light-success"
                  class="ml-1"
                >
                  active
                </b-badge>
              </template>
              <template #cell(actions)="data">
                <div
                  v-if="editingSessionManageId === data.item.id"
                  class="d-flex"
                >
                  <b-button
                    size="sm"
                    variant="primary"
                    class="btn-icon mr-50"
                    :disabled="savingSessionManageEdit"
                    @click="saveSessionManageEdit()"
                  >
                    <b-spinner v-if="savingSessionManageEdit" small />
                    <feather-icon v-else icon="CheckIcon" size="16" />
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    class="btn-icon"
                    :disabled="savingSessionManageEdit"
                    @click="cancelEditSessionManage()"
                  >
                    <feather-icon icon="XIcon" size="16" />
                  </b-button>
                </div>
                <div v-else class="d-flex align-items-center">
                  <b-button
                    v-if="rights.edit && canManage"
                    size="sm"
                    variant="outline-primary"
                    class="btn-icon"
                    :class="{
                      'mr-50':
                        (data.item.status || '').toLowerCase() !== 'active',
                    }"
                    @click="startEditSessionManage(data.item)"
                  >
                    <feather-icon icon="EditIcon" size="16" />
                  </b-button>
                  <b-button
                    v-if="
                      rights.edit &&
                      canManage &&
                      (data.item.status || '').toLowerCase() !== 'active'
                    "
                    size="sm"
                    variant="outline-primary"
                    class="btn-icon"
                    :disabled="markingActiveSessionId === data.item.id"
                    @click="markSessionActive(data.item.id)"
                  >
                    <b-spinner
                      v-if="markingActiveSessionId === data.item.id"
                      small
                    />
                    <feather-icon v-else icon="CheckCircleIcon" size="16" />
                  </b-button>
                </div>
              </template>
            </b-table>
          </div>
        </b-modal>

        <b-card>
          <b-row align-h="end" class="text-right">
            <b-col class="mt-xl-0 mt-lg-0 mt-md-0 mt-sm-1 mt-1" cols="11">
              <b-dropdown
                v-for="(d, ind) in this.myDepartments"
                :key="ind"
                class="mx-25 mb-25"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                split
                :text="d.name"
                :variant="current == d.id ? 'primary' : 'outline-primary'"
                right
                @click="LoadClasses(d.id)"
              >
                <b-dropdown-item
                  @click="EditDep(d)"
                  v-if="rights.edit && canManage"
                >
                  {{ $t("Edit") }}
                </b-dropdown-item>

                <b-dropdown-item
                  @click="openTimings(d)"
                  v-if="
                    dtObj &&
                    dtObj.valueBool &&
                    (rights.add || rights.edit) &&
                    canManage
                  "
                >
                  {{ $t("Timings") }}
                </b-dropdown-item>

                <b-dropdown-item
                  @click="DeleteDep(d.id)"
                  v-if="rights.delete && canManage"
                >
                  {{ $t("Delete") }}
                </b-dropdown-item>
              </b-dropdown>
            </b-col>
            <b-col
              v-if="rights.add && canManage"
              class="mt-xl-0 mt-lg-0 mt-md-0 mt-sm-1 mt-1"
              style="margin-right: 8px"
              cols="*"
            >
              <b-button
                @click="OpenDepartmentF()"
                style=""
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-icon rounded-circle"
              >
                <feather-icon size="16" icon="PlusIcon" />
              </b-button>
            </b-col>
          </b-row>
          <b-row class="mt-1 mb-50">
            <b-col
              v-if="isHappiness && rights.add && canManage"
              xl="2"
              lg="3"
              md="4"
              sm="6"
              cols="12"
              class="mt-lg-0 mt-md-0 mt-sm-1 mt-1"
            >
              <b-button
                @click="openSessionsManageModal()"
                block
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
              >
                <feather-icon icon="PlusIcon" class="mr-50" />
                <span class="align-middle">{{ $t(sessionLabel) }}</span>
              </b-button>
            </b-col>
            <b-col
              v-if="rights.add && canManage"
              xl="2"
              lg="3"
              md="4"
              sm="6"
              cols="12"
              class="mt-lg-0 mt-md-0 mt-sm-1 mt-1"
            >
              <b-button
                @click="AddOpen()"
                block
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
              >
                <feather-icon icon="PlusIcon" class="mr-50" />
                <span class="align-middle">{{ $t(classLabel) }}</span>
              </b-button>
            </b-col>
            <b-col
              v-if="!isHappiness && rights.add && canManage"
              xl="2"
              lg="3"
              md="4"
              sm="6"
              cols="12"
              class="mt-lg-0 mt-md-0 mt-sm-1 mt-1"
            >
              <b-button
                @click="openSectionsModal()"
                block
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
              >
                <feather-icon icon="PlusIcon" class="mr-50" />
                <span class="align-middle">{{ $t(sectionLabel) }}</span>
              </b-button>
            </b-col>
            <template v-if="isHappiness">
              <b-col
                v-if="rights.add && canManage"
                xl="2"
                lg="3"
                md="4"
                sm="6"
                cols="12"
                class="mt-lg-0 mt-md-0 mt-sm-1 mt-1"
              >
                <b-button
                  @click="openSubjectsModal()"
                  block
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                >
                  <feather-icon icon="PlusIcon" class="mr-50" />
                  <span class="align-middle">{{ $t("Subject") }}</span>
                </b-button>
              </b-col>
              <b-col
                v-if="rights.add && canManage"
                xl="2"
                lg="3"
                md="4"
                sm="6"
                cols="12"
                class="mt-lg-0 mt-sm-1 mt-1"
              >
                <b-button
                  @click="openSectionsModal()"
                  block
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                >
                  <feather-icon icon="PlusIcon" class="mr-50" />
                  <span class="align-middle">{{ $t(sectionLabel) }}</span>
                </b-button>
              </b-col>
              <b-col
                v-if="rights.add && canManage"
                xl="2"
                lg="3"
                md="4"
                sm="6"
                cols="12"
                class="mt-xl-0 mt-1"
              >
                <b-button
                  @click="openDropdownModal('ageCategory')"
                  block
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                >
                  <feather-icon icon="PlusIcon" class="mr-50" />
                  <span class="align-middle">{{ $t("Age Category") }}</span>
                </b-button>
              </b-col>
              <b-col
                v-if="rights.add && canManage"
                xl="2"
                lg="3"
                md="4"
                sm="6"
                cols="12"
                class="mt-xl-0 mt-1"
              >
                <b-button
                  @click="openDropdownModal('empowerLevel')"
                  block
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                >
                  <feather-icon icon="PlusIcon" class="mr-50" />
                  <span class="align-middle">{{ $t("Empower Level") }}</span>
                </b-button>
              </b-col>
            </template>

            <b-col
              class="mt-sm-1 mt-1 d-flex align-items-center justify-content-between"
              :class="isHappiness ? 'mt-lg-1' : 'mt-lg-0'"
              :xl="isHappiness ? 12 : 8"
              :lg="isHappiness ? 12 : 6"
              md="12"
              sm="12"
              cols="12"
            >
              <b-form-group class="mb-0 pr-50 w-100">
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <feather-icon icon="SearchIcon" />
                  </b-input-group-prepend>

                  <b-form-input
                    v-model="searchQuery"
                    :placeholder="$t('Search') + '...'"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-group>
              <!-- <b-button
                v-if="rights.edit && canManage"
                variant="outline-primary"
                v-b-tooltip.hover.top
                title="Shift Classes"
                class="btn-icon mr-50"
                :disabled="loadingSh"
                @click="openShift()"
              >
                <b-spinner v-if="loadingSh" small />
                <feather-icon v-else icon="CheckCircleIcon" class="" />
              </b-button> -->
              <b-button
                v-if="rights.edit && canManage"
                variant="outline-primary"
                v-b-tooltip.hover.top
                :title="$t('Shift ' + classLabel)"
                class="btn-icon"
                :disabled="loadingSh"
                @click="openSingle()"
              >
                <feather-icon icon="ShuffleIcon" class="" />
              </b-button>
            </b-col>
          </b-row>
          <b-table
            class="mt-1"
            ref="selectableTable"
            :items="items"
            :fields="fields"
            :busy="gridLoading"
            :per-page="perPage"
            :current-page="currentPage"
            show-empty
            responsive
            hover
            :selectable="rights.edit && canManage && !editLoading"
            select-mode="single"
            @row-selected="Edit($event[0].cls.id, false)"
          >
            <template #empty>
              <h3 class="mt-1 mb-1 text-center">
                {{ $t("No records found") }}
              </h3>
            </template>
            <template #table-busy>
              <div class="d-flex justify-content-center mb-3 mt-3">
                <b-spinner
                  style="width: 3rem; height: 3rem"
                  type="grow"
                  variant="primary"
                  :label="$t('Spinning')"
                ></b-spinner>
              </div>
            </template>

            <template #head()="scope">
              <div>
                {{
                  $t(
                    scope.label == "Class"
                      ? classLabel
                      : scope.label == "Sections"
                      ? sectionLabel
                      : scope.label
                  )
                }}
              </div>
            </template>

            <template #head(drag)>
              <div class="text-center">
                <span>{{ $t("Drag") }}</span>
              </div>
            </template>

            <template #cell(drag)>
              <div class="text-center">
                <feather-icon
                  icon="MoveIcon"
                  size="16"
                  class="drag-handle cursor-move"
                  style="color: #6c757d"
                />
              </div>
            </template>

            <template #cell(name)="data">
              <div class="d-flex align-items-center">
                <svg
                  class="drag-handle cursor-move mr-2"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="color: #6c757d; min-width: 16px"
                >
                  <rect
                    x="2"
                    y="4"
                    width="10"
                    height="1.5"
                    rx="0.75"
                    fill="currentColor"
                  />
                  <rect
                    x="2"
                    y="8.5"
                    width="10"
                    height="1.5"
                    rx="0.75"
                    fill="currentColor"
                  />
                </svg>
                <b-badge variant="light-primary">
                  {{ data.item.cls.name }}
                </b-badge>
              </div>
            </template>

            <template #cell(sections)="data">
              <div v-if="data.item.sections != null">
                <b-badge
                  v-for="i in data.item.sections"
                  :key="i.id"
                  variant="light-primary"
                  class="mx-25 mb-25"
                >
                  {{ i.section }}
                </b-badge>
              </div>
            </template>

            <template #cell(status)="data">
              <div
                class="d-flex align-items-center ml-1"
                v-if="rights.edit && canManage"
              >
                <b-form-checkbox
                  v-model="data.item.cls.status"
                  :value="'active'"
                  :unchecked-value="'inactive'"
                  switch
                  size="lg"
                  class="status-toggle"
                  @change="
                    changeStatus(
                      data.item.cls,
                      data.item.cls.status === 'active'
                    )
                  "
                  :disabled="editLoading"
                />
              </div>
              <!-- <div v-else class="d-flex align-items-center justify-content-center">
                <b-badge
                  :variant="data.item.cls.status === 'active' ? 'light-success' : 'light-danger'"
                  class="status-badge"
                >
                  {{ data.item.cls.status === 'active' ? 'Active' : 'Inactive' }}
                </b-badge>
              </div> -->
            </template>

            <template #cell(actions)="data">
              <div class="d-flex align-items-start">
                <!-- <template v-if="rights.edit && reportDomain == 'myskoolhpgs' ">
                  <b-button
                    v-if="data.item.cls.status == 'active'"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-danger"
                    v-b-tooltip.hover.left
                    title="Inactive Class"
                    class="btn-icon mr-1"
                    @click.stop="changeStatus(data.item.cls, false)"
                  >
                    <feather-icon icon="XCircleIcon" />
                  </b-button>
                  <b-button
                    v-else
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-success"
                    v-b-tooltip.hover.left
                    title="Active Class"
                    class="btn-icon mr-1"
                    @click.stop="changeStatus(data.item.cls, true)"
                  >
                    <feather-icon icon="CheckCircleIcon" />
                  </b-button>
                </template> -->

                <b-button
                  v-if="rights.assignSections && canManage"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  v-b-tooltip.hover.left
                  :title="$t('Assign Sections')"
                  class="btn-icon mr-1"
                  :disabled="editLoading || secLoading"
                  @click.stop="Edit(data.item.cls.id, true)"
                >
                  <b-spinner
                    v-if="secLoading && currentID == data.item.cls.id"
                    small
                  />
                  <feather-icon v-else icon="PlusCircleIcon" />
                </b-button>

                <b-button
                  v-if="rights.edit && canManage"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  v-b-tooltip.hover.left
                  :title="$t('Edit')"
                  class="btn-icon mr-1"
                  :disabled="editLoading || secLoading"
                  @click.stop="Edit(data.item.cls.id, false)"
                >
                  <b-spinner
                    v-if="editLoading && currentID == data.item.cls.id"
                    small
                  />
                  <feather-icon v-else icon="EditIcon" class="" />
                </b-button>

                <!-- <b-button
                  v-if="rights.delete && canManage"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-danger"
                  v-b-tooltip.hover.right
                  :title="$t('Delete')"
                  class="btn-icon mr-1"
                  @click="Delete(data.item.cls.id)"
                >
                  <feather-icon icon="Trash2Icon" />
                </b-button> -->

                <b-button
                  v-if="rights.edit && canManage"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  v-b-tooltip.hover.right
                  :title="$t('Left ' + classLabel)"
                  class="btn-icon"
                  @click="openLeft(data.item.cls.id, data.item.cls.name)"
                >
                  <!-- @click="leftClass(data.item.cls.id, '')" -->
                  <feather-icon icon="LogOutIcon" />
                </b-button>
                <!-- <b-button
                  v-if="rights.edit && canManage"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  v-b-tooltip.hover.right
                  title="Mark Alumni"
                  class="btn-icon mr-1"
                  @click="leftClass(data.item.cls.id, 'alumni')"
                >
                  <feather-icon icon="UserCheckIcon" />
                </b-button> -->

                <!-- <b-button
                  v-if="
                    rights.edit &&
                    (currentPage - 1) * perPage + data.index + 1 <=
                      items.length - 1
                  "
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  v-b-tooltip.hover.right
                  title="Move Down"
                  class="btn-icon mr-1"
                >
                  <feather-icon icon="ArrowDownIcon" />
                </b-button>
                <b-button
                  v-if="
                    rights.edit &&
                    (currentPage - 1) * perPage + data.index + 1 != 1
                  "
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  v-b-tooltip.hover.right
                  title="Move Up"
                  class="btn-icon mr-1"
                >
                  <feather-icon icon="ArrowUpIcon" />
                </b-button> -->
              </div>
            </template>
          </b-table>

          <!-- Pagination at the bottom -->
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-center mt-3"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength, between } from "vuelidate/lib/validators";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BMediaAside,
  BAside,
  BSpinner,
  BCardTitle,
  BCardText,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
  BModal,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Sortable from "sortablejs";
import axios from "axios";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    flatPickr,
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BForm,
    BPagination,
    BSpinner,
    BDropdown,
    BDropdownItem,
    BModal,
    vSelect,
  },
  props: {},
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    let right = {};
    this.$store.state.menu.forEach((el) => {
      el.children.forEach((ch) => {
        right[ch.route] = {
          view: ch.view,
          add: ch.add,
          edit: ch.edit,
          delete: ch.delete,
          assignSections: ch.assignSections,
        };
      });
    });
    this.$store.commit("setRights", right);
    // console.log(this.$store.state.rights);

    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      this.LoadDepartments();
      this.LoadClasses(0);
      this.loadSettings();
      this.LoadSettingsAll();
      this.LoadLeftCat();
      if (this.isCoaching) this.LoadSessions();
      // if (this.reportDomain == "myskoolhpgs") {
      this.fields.splice(2, 0, { label: "Status", key: "status" });
      // }
    }
  },
  computed: {
    filters: function () {
      return this.items.filter((pro) => {
        return pro.name.toLowerCase().match(this.searchQuery.toLowerCase());
      });
    },
    isHappiness() {
      return this.reportDomain == "myskoolhappinessfoundation";
    },
    classLabel: function () {
      return this.isHappiness ? "Group" : "Class";
    },
    sectionLabel: function () {
      return this.isHappiness ? "Level" : "Section";
    },
    sessionLabel: function () {
      return this.isHappiness ? "Semester" : "Session";
    },
    isTcfDomain() {
      return ["myskooltcfdemo", "myskooltcf"].includes(this.reportDomain);
    },
    canManage() {
      if (this.isTcfDomain) {
        return !!this.isHeadOffice;
      }
      return true;
    },
    filteredModalSections() {
      if (!this.sectionModalSearch) return this.sections;
      const query = this.sectionModalSearch.toLowerCase();
      return this.sections.filter((sec) =>
        sec.section.toLowerCase().includes(query)
      );
    },
    filteredModalSubjects() {
      if (!this.subjectModalSearch) return this.subjectsList;
      const query = this.subjectModalSearch.toLowerCase();
      return this.subjectsList.filter(
        (sub) => sub.subject && sub.subject.toLowerCase().includes(query)
      );
    },
    filteredDropdownModalItems() {
      if (!this.dropdownModalSearch) return this.dropdownModalItems;
      const query = this.dropdownModalSearch.toLowerCase();
      return this.dropdownModalItems.filter((item) =>
        (item.title || "").toLowerCase().includes(query)
      );
    },
    filteredModalSessions() {
      if (!this.sessionModalSearch) return this.sessionsList;
      const query = this.sessionModalSearch.toLowerCase();
      return this.sessionsList.filter(
        (s) => s.session && s.session.toLowerCase().includes(query)
      );
    },
  },
  data() {
    return {
      rights: {},
      myDepartments: [],
      request: false,
      visibility1: false,
      visibility3: false,
      visibility4: false,
      singleObj: {
        clsFrom: 0,
        secFrom: 0,
        clsTo: 0,
        secTo: 0,
      },
      currentSections: [],
      moveSections: [],
      sidebarTitle: "Add Class",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataloading: false,
      gridLoading: false,
      visibility: false,
      logoloading: "",
      searchQuery: "",
      currentPage: 1,
      perPage: 30,
      totalRows: null,
      index: null,
      loadingSh: false,
      shifting: false,
      shiftData: [],
      shiftFields: [
        { label: "Class", key: "current_class" },
        { label: "Move to", key: "move_to" },
      ],
      fields: [
        { label: "Class", key: "name" },
        { label: "Sections", key: "sections" },
        { key: "actions", label: "actions" },
      ],
      allClasses: [],
      items: [],
      sections: [],
      selecting: true,
      savingSection: false,
      sectionsModalVisible: false,
      loadingSections: false,
      editingSectionId: null,
      editingSectionName: "",
      editingSectionObj: null,
      savingSectionEdit: false,
      sectionModalSearch: "",
      sectionModalFields: [
        { label: "Name", key: "section" },
        { key: "actions", label: "actions" },
      ],
      selected: null,
      sectionObj: {
        id: 0,
        section: "",
        campusID: this.$store.state.userData.cId,
      },
      subjectsList: [],
      subjectsModalVisible: false,
      loadingSubjects: false,
      editingSubjectId: null,
      editingSubjectName: "",
      editingSubjectObj: null,
      savingSubjectEdit: false,
      subjectModalSearch: "",
      subjectModalFields: [
        { label: "Name", key: "subject" },
        { key: "actions", label: "actions" },
      ],
      subjectObj: {
        id: 0,
        subject: "",
        campusID: this.$store.state.userData.cId,
        isOptional: false,
        school: null,
      },
      savingSubject: false,
      dropdownModalVisible: false,
      dropdownModalCategory: "",
      dropdownModalTitle: "",
      dropdownModalItems: [],
      dropdownModalSearch: "",
      dropdownFormTitle: "",
      dropdownEditingId: null,
      dropdownEditingTitle: "",
      dropdownSaving: false,
      dropdownLoading: false,
      dropdownModalFields: [
        { label: "Name", key: "title" },
        { key: "actions", label: "actions" },
      ],
      sessionsList: [],
      sessionsModalManageVisible: false,
      loadingSessionsList: false,
      editingSessionManageId: null,
      editingSessionManageName: "",
      editingSessionManageObj: null,
      savingSessionManageEdit: false,
      sessionModalSearch: "",
      sessionModalFields: [
        { label: "Name", key: "session" },
        { key: "actions", label: "actions" },
      ],
      sessionManageObj: {
        id: 0,
        session: "",
        campusID: this.$store.state.userData.cId,
        isCurrentSession: false,
        status: "",
      },
      savingSessionManage: false,
      markingActiveSessionId: null,
      allSectionIDs: [],
      rangeDate: null,
      myObj: {
        cls: {
          id: 0,
          name: "",
          sections: "",
          departmentID: 0,
          campusID: this.$store.state.userData.cId,
          startsAt: null,
        },
        sectionIDs: [],
      },
      depObj: {
        id: 0,
        name: "",
        sequence: 0,
        whatsAppCampusID: 0,
        campusID: this.$store.state.userData.cId,
      },
      current: 0,
      settObj: null,
      dtObj: null,
      stdObj: null,
      leftCls: 0,
      leftName: "",
      lefting: false,
      visibility8: false,
      leftSelected: "None",
      leftOptions: [],
      catFields: [
        { label: "Name", key: "title" },
        { key: "actions", label: "actions" },
      ],
      visibility9: false,
      catObj: {},
      savingCat: false,
      sameDays: this.$store.state.sameTimings,
      timeObj: null,
      currDays: [],
      visibility5: false,
      timeLoading: false,
      savingTime: false,
      timingInfo: [],
      daysList: [
        { text: "Monday", value: "monday" },
        { text: "Tuesday", value: "tuesday" },
        { text: "Wednesday", value: "wednesday" },
        { text: "Thursday", value: "thursday" },
        { text: "Friday", value: "friday" },
        { text: "Saturday", value: "saturday" },
        { text: "Sunday", value: "sunday" },
      ],
      currentDepID: 0,
      currentDepName: 0,
      syncing: false,
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      isHeadOffice: false,
      feePopup: null,
      currentID: 0,
      editLoading: false,
      secLoading: false,
      secVisibility: false,
      sortable: null,
      isCoaching:
        this.$store.state.currentBranch.organizationType == "coaching",
      sessions: [],
      leftSessionID: 0,
    };
  },
  validations: {
    depObj: {
      name: {
        required,
        minLength: minLength(4),
      },
    },
    age: {
      between: between(20, 30),
    },
  },
  mounted() {
    this.initSortable();
  },
  methods: {
    ...mapActions({
      get: "get",
      post: "post",
      put: "put",
      delete: "delete",
      postObj: "postObj",
    }),

    initSortable() {
      this.$nextTick(() => {
        const tbody = this.$refs.selectableTable.$el.querySelector("tbody");
        if (tbody) {
          this.sortable = Sortable.create(tbody, {
            handle: ".drag-handle",
            animation: 150,
            ghostClass: "sortable-ghost",
            chosenClass: "sortable-chosen",
            dragClass: "sortable-drag",
            onEnd: (evt) => {
              this.handleReorder(evt);
            },
          });
        }
      });
    },

    async handleReorder(evt) {
      const { oldIndex, newIndex } = evt;

      if (oldIndex === newIndex) return;

      // Calculate global positions considering pagination
      const globalOldIndex = (this.currentPage - 1) * this.perPage + oldIndex;
      const globalNewIndex = (this.currentPage - 1) * this.perPage + newIndex;

      console.log("Drag event:", {
        oldIndex,
        newIndex,
        globalOldIndex,
        globalNewIndex,
      });

      // Get the moved item
      const movedItem = this.items[oldIndex];

      // Remove from old position and insert at new position in the current page items
      this.items.splice(oldIndex, 1);
      this.items.splice(newIndex, 0, movedItem);

      // Call API to update the order using global position (1-based indexing)
      await this.updateClassOrder(movedItem.cls.id, globalNewIndex + 1);
    },

    async updateClassOrder(classId, newPosition) {
      try {
        console.log(`Updating class ${classId} to position ${newPosition}`);

        // newPosition is already 1-based, so use it directly
        const response = await axios.put(
          `${this.$store.state.domain}MyClasses/SetSequence?db=${this.$store.state.userData.db}&id=${classId}&campusID=${this.$store.state.userData.cId}&index=${newPosition}`,
          null,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.userData.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data && response.data.status === "success") {
          this.$bvToast.toast(
            response.data.message ||
              this.classLabel + " order updated successfully.",
            {
              title: "Success!",
              variant: "success",
              toaster: "b-toaster-top-right",
            }
          );

          // Reload the current page data to ensure consistency
          await this.LoadClasses(this.current);
        } else {
          throw new Error("Failed to update class order");
        }
      } catch (error) {
        console.error("Error updating class order:", error);
        this.$bvToast.toast("Failed to update " + this.classLabel + " order.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
        // Reload to restore original order
        await this.LoadClasses(this.current);
      }
    },

    openTimings(item) {
      this.currentDepID = item.id;
      this.currentDepName = item.name;
      this.visibility5 = true;

      this.LoadTimings();
    },
    async LoadTimings() {
      this.timeLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "DepartmentTimings/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&id=" +
          this.currentDepID,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      this.timeLoading = false;

      if (res.length == 0) {
        this.timingInfo = [
          {
            id: 0,
            depID: this.currentDepID,
            day: "monday",
            timeIn: "",
            timeOut: "",
            isActive: true,
            campusID: this.$store.state.userData.cId,
          },
        ];
      } else this.timingInfo = res;
      this.changeDay();
    },
    changeDay() {
      this.currDays = this.timingInfo.reduce((acc, el) => {
        acc.push(el.day);
        return acc;
      }, []);
      // console.log(this.currDays);
    },
    setDays(item) {
      this.$store.commit("setSameTimings", this.sameDays);

      this.$nextTick(() => {
        // console.log(item.timeOut);
        if (
          this.timingInfo.length == 1 &&
          this.sameDays &&
          item.day == "monday" &&
          item.timeIn &&
          item.timeOut
        ) {
          // console.log(item);
          let days = ["tuesday", "wednesday", "thursday", "friday", "saturday"];
          let data = [item];
          days.forEach((el) => {
            data.push({
              id: 0,
              depID: item.depID,
              day: el,
              timeIn: item.timeIn,
              timeOut: item.timeOut,
              isActive: true,
              campusID: this.$store.state.userData.cId,
            });
          });
          this.timingInfo = data;
          this.changeDay();
        }
      });
    },
    addDay() {
      this.timingInfo.push({
        id: 0,
        depID: this.currentDepID,
        day: "",
        timeIn: "",
        timeOut: "",
        isActive: true,
        campusID: this.$store.state.userData.cId,
      });
      // console.log(this.timingInfo);
    },
    async removeDay(item, ind) {
      if (item.id == 0) {
        this.timingInfo.splice(ind, 1);
        // console.log(this.timingInfo);
        this.currDays = this.currDays.filter((el) => el != item.day);
      } else {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "DepartmentTimings/" +
            item.id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          grading: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.timingInfo.splice(ind, 1);
          this.currDays = this.currDays.filter((el) => el != item.day);
        }
        // console.log(this.timingInfo);
      }
    },
    CheckTimings() {
      let state = true;
      // this.timingInfo = this.timingInfo.filter(
      //   (el) => el.day != "" && el.timeIn != "" && el.timeOut != ""
      // );
      this.timingInfo.forEach((el) => {
        if (el.day == "" || !el.timeIn || !el.timeOut) {
          state = false;
        }
      });
      // console.log(state);
      return state;
    },
    async saveTimings() {
      // console.log(this.timingInfo);
      if (this.CheckTimings() == true) {
        this.savingTime = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "DepartmentTimings/SaveData?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: this.timingInfo,
          message: "Timings saved successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.savingTime = false;
        if (status) {
          this.LoadTimings();
        }
      } else {
        this.$bvToast.toast("Please enter the timings correctly!", {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
      }
    },
    async syncTimings() {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text:
          "This will sync the student timings for all classes of " +
          this.currentDepName,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      });
      if (result.isConfirmed) {
        this.syncing = true;
        this.$bvToast.toast("Student timings are being sync", {
          title: "Syncing",
          variant: "success",
          toaster: "b-toaster-top-right",
        });

        var status = await this.postObj({
          url:
            this.$store.state.domain +
            "DepartmentTimings/SyncData?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&id=" +
            this.currentDepID,
          message: "Student timings synced successfully",
          context: this,
          ignoreTimeout: true,
          token: this.$store.state.userData.token,
        });
        this.syncing = false;
      }
    },

    openLeft(id, name) {
      this.leftCls = id;
      this.leftName = name;
      this.leftSelected = "None";
      this.leftSessionID = 0;
      this.visibility8 = true;
    },
    async LoadLeftCat() {
      var obj = {
        url:
          this.$store.state.domain +
          "DropDownList/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&category=leftCategories",
        token: this.$store.state.userData.token,
      };
      this.leftOptions = await this.get(obj);
    },
    openCat() {
      this.catObj = {
        id: 0,
        title: "",
        typee: "leftCategories",
        campusID: this.$store.state.userData.cId,
      };
      this.visibility9 = true;
      var elem = this.$refs["cat_name"];
      elem.state = undefined;
    },
    checkCat() {
      var elem = this.$refs["cat_name"];
      if (this.catObj.title.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveCat() {
      if (this.checkCat() == true) {
        this.savingCat = true;
        if (this.catObj.id == 0) {
          var status = await this.post({
            url:
              this.$store.state.domain +
              "DropDownList?db=" +
              this.$store.state.userData.db,
            body: this.catObj,
            message: "Category added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          var status = await this.put({
            url:
              this.$store.state.domain +
              "DropDownList/" +
              this.catObj.id +
              "?db=" +
              this.$store.state.userData.db,
            message: "Category updated successfully.",
            context: this,
            body: this.catObj,
            token: this.$store.state.userData.token,
          });
        }
        if (status) {
          this.LoadLeftCat();
          this.catObj = {
            id: 0,
            title: "",
            typee: "leftCategories",
            campusID: this.$store.state.userData.cId,
          };
          var elem = this.$refs["cat_name"];
          elem.state = undefined;
        }
        this.savingCat = false;
      }
    },
    async editCat(acc) {
      this.catObj = { ...acc };
      var elem = this.$refs["cat_name"];
      elem.state = undefined;
    },
    async deleteCat(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "DropDownList/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          message: "Category deleted successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadLeftCat();
      }
    },

    async loadSettings() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: [
          "multi_whatsapp",
          "department-timings",
          "studentTimings",
          "head_office",
        ],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      // console.log(res);
      this.settObj = res.find((el) => el.key == "multi_whatsapp");
      this.dtObj = res.find((el) => el.key == "department-timings");
      this.stdObj = res.find((el) => el.key == "studentTimings");
      if (this.isTcfDomain) {
        const headOfficeObj = res.find((el) => el.key == "head_office");
        this.isHeadOffice =
          headOfficeObj &&
          headOfficeObj.campusID == this.$store.state.userData.cId;
      }
      // console.log(this.settObj);
    },
    async LoadSettingsAll() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db,
        body: ["update_fee_popup"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.feePopup = res.find((el) => el.key == "update_fee_popup");
    },
    async LoadSessions() {
      var obj = {
        url:
          this.$store.state.domain +
          "Sessions?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.sessions = await this.get(obj);
    },

    getClassName(id) {
      return this.allClasses.find((el) => el.id == id).name;
    },

    openSingle() {
      this.singleObj = {
        clsFrom: 0,
        secFrom: 0,
        clsTo: 0,
        secTo: 0,
      };
      this.visibility4 = true;
      this.currentSections = [];
      this.moveSections = [];
    },
    fillCurrent() {
      this.singleObj.secFrom = 0;

      this.currentSections = this.items.find(
        (el) => el.cls.id == this.singleObj.clsFrom
      ).sections;

      this.checkSame();
    },
    fillMove() {
      this.singleObj.secTo = 0;

      this.moveSections = this.items.find(
        (el) => el.cls.id == this.singleObj.clsTo
      ).sections;

      this.checkSame();
    },
    checkSame() {
      this.currentSections = this.items.find(
        (el) => el.cls.id == this.singleObj.clsFrom
      ).sections;

      this.moveSections = this.items.find(
        (el) => el.cls.id == this.singleObj.clsTo
      ).sections;

      if (this.singleObj.clsTo == this.singleObj.clsFrom) {
        // for current
        this.currentSections = this.currentSections.filter(
          (el) => el.id != this.singleObj.secTo
        );

        // for move
        this.moveSections = this.moveSections.filter(
          (el) => el.id != this.singleObj.secFrom
        );
      }
    },

    async ShiftSingle() {
      if (
        this.singleObj.clsFrom == 0 ||
        this.singleObj.secFrom == 0 ||
        this.singleObj.clsTo == 0 ||
        this.singleObj.secTo == 0
      ) {
        this.$bvToast.toast("Please enter the details!", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
      } else {
        // console.log(this.singleObj);
        this.shifting = true;

        var status = await this.post({
          url:
            this.$store.state.domain +
            "MyClasses/ShiftSingle?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: this.singleObj,
          message: this.$t(this.classLabel + " shifted successfully."),
          context: this,
          token: this.$store.state.userData.token,
        });
        this.shifting = false;

        if (status) {
          this.visibility4 = false;
        }
      }
    },

    async openShift() {
      this.loadingSh = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Students/LoadShiftData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.shiftData = await this.get(obj);
      // console.log(this.shiftData);
      this.loadingSh = false;
      this.visibility3 = true;
    },
    async Shift() {
      this.shifting = true;
      var status = await this.post({
        url:
          this.$store.state.domain +
          "Students/ShiftClass?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: this.shiftData,
        message: this.$t(this.classLabel + " shift successfully."),
        context: this,
        token: this.$store.state.userData.token,
      });
      this.shifting = false;
      if (status) {
        this.visibility3 = false;
      }
    },

    async EditDep(item) {
      // var obj = {
      //   url:
      //     this.$store.state.domain +
      //     "Departments/GetSelected?id=" +
      //     item.id +
      //     "&db=" +
      //     this.$store.state.userData.db,
      //   token: this.$store.state.userData.token,
      // };
      // this.depObj = await this.get(obj);
      this.depObj = { ...item };
      // console.log("editObj:", this.depObj);
      this.sidebarTitle = "Edit Department";
      this.sidebarButton = "Update";
      this.visibility1 = true;
      var elem = this.$refs["depname"];
      elem.state = undefined;
    },

    OpenDepartmentF() {
      this.depObj = {
        id: 0,
        name: "",
        sequence: 0,
        whatsAppCampusID: 0,
        campusID: this.$store.state.userData.cId,
      };
      this.sidebarTitle = "Add Department";
      this.sidebarButton = "Save";
      this.visibility1 = true;
      var elem = this.$refs["depname"];
      elem.state = undefined;
    },

    async Edit(id, isSection) {
      this.currentID = id;

      if (isSection) {
        this.secLoading = true;
      } else {
        this.editLoading = true;
      }

      var obj = {
        url:
          this.$store.state.domain +
          "MyClasses/GetSelectedClass?db=" +
          this.$store.state.userData.db +
          "&clsID=" +
          id,
        token: this.$store.state.userData.token,
      };
      let result = await this.get(obj);
      // console.log("editObj", result);
      this.myObj.cls = result.cls;
      await this.getSections();

      this.editLoading = false;
      this.secLoading = false;
      this.currentID = 0;

      this.allSectionIDs = result.sections
        ? result.sections.map((el) => el.id)
        : [];

      // for assigning sections
      if (isSection) {
        this.secVisibility = true;
        var elem = this.$refs["sections"];
        elem.state = undefined;
      } else {
        this.visibility = true;
        this.selecting = true;

        this.sidebarTitle = "Edit " + this.classLabel;
        this.sidebarButton = "Update";
        this.buttonIcon = "EditIcon";
        var elem = this.$refs["name"];
        elem.state = undefined;
        var elem = this.$refs["department"];
        elem.state = undefined;
        var elem = this.$refs["sections"];
        elem.state = undefined;
      }
    },

    async AddOpen() {
      this.allSectionIDs = [];
      this.selecting = true;
      this.getSections();
      this.visibility = true;
      this.myObj.cls.id = 0;
      this.myObj.cls.departmentID = 0;
      this.myObj.cls.campusID = this.$store.state.userData.cId;
      this.myObj.cls.sections = "";
      this.myObj.cls.name = "";
      this.myObj.cls.status = "active";
      this.myObj.cls.startsAt = null;
      this.sidebarTitle = "Add " + this.classLabel;
      this.sidebarButton = "Save";
      var elem = this.$refs["name"];
      elem.state = undefined;
      var elem = this.$refs["department"];
      elem.state = undefined;
      var elem = this.$refs["sections"];
      elem.state = undefined;
    },
    async getSections() {
      var obj = {
        url:
          this.$store.state.domain +
          "Sections?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.sections = await this.get(obj);
      // console.log("sections:", this.sections);
      this.sections = this.sections.filter(
        (el) => el.section != null && el.section != ""
      );
      this.sections = this.sections.sort((s1, s2) => {
        // console.log(s1);
        // console.log(s2);
        if (s1 != null && s2 != null && s1 != undefined && s2 != undefined)
          s1.section.toUpperCase() > s2.section.toUpperCase()
            ? 1
            : s1.section.toUpperCase() < s2.section.toUpperCase()
            ? -1
            : 0;
      });
      // console.log(sorted);
    },
    async getSubjects() {
      var obj = {
        url:
          this.$store.state.domain +
          "Subjects?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.subjectsList = await this.get(obj);
      if (Array.isArray(this.subjectsList)) {
        this.subjectsList = this.subjectsList.filter(
          (el) => el.subject != null && el.subject != ""
        );
        this.subjectsList.sort((s1, s2) => {
          if (s1.subject && s2.subject) {
            return s1.subject.localeCompare(s2.subject);
          }
          return 0;
        });
      } else {
        this.subjectsList = [];
      }
    },
    async openSubjectsModal() {
      this.subjectsModalVisible = true;
      this.editingSubjectId = null;
      this.editingSubjectName = "";
      this.subjectModalSearch = "";
      this.subjectObj.subject = "";
      this.loadingSubjects = true;
      await this.getSubjects();
      this.loadingSubjects = false;
    },
    closeSubjectsModal() {
      this.subjectsModalVisible = false;
      this.editingSubjectId = null;
      this.editingSubjectName = "";
      this.editingSubjectObj = null;
      this.subjectModalSearch = "";
      this.subjectObj.subject = "";
    },
    startEditSubject(sub) {
      this.editingSubjectId = sub.id;
      this.editingSubjectName = sub.subject;
      this.editingSubjectObj = { ...sub };
    },
    cancelEditSubject() {
      this.editingSubjectId = null;
      this.editingSubjectName = "";
      this.editingSubjectObj = null;
    },
    async saveSubjectEdit() {
      if (!this.editingSubjectName || this.editingSubjectName.trim() == "") {
        return this.$bvToast.toast(this.$t("Please enter the subject name."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
      }
      this.savingSubjectEdit = true;
      const currentObj =
        this.editingSubjectObj ||
        this.subjectsList.find((s) => s.id === this.editingSubjectId) ||
        {};
      var status = await this.put({
        url:
          this.$store.state.domain +
          "Subjects/" +
          this.editingSubjectId +
          "?db=" +
          this.$store.state.userData.db +
          "&userID=" +
          this.$store.state.userData.userID,
        body: {
          ...currentObj,
          subject: this.editingSubjectName.trim(),
        },
        message: this.$t("Subject updated successfully."),
        context: this,
        token: this.$store.state.userData.token,
      });
      this.savingSubjectEdit = false;
      if (status) {
        this.cancelEditSubject();
        await this.getSubjects();
      }
    },
    async postSubject() {
      if (!this.subjectObj.subject || this.subjectObj.subject.trim() == "") {
        return this.$bvToast.toast(this.$t("Please enter the subject name."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
      }
      this.savingSubject = true;
      var status = await this.post({
        url:
          this.$store.state.domain +
          "Subjects/AddMultiple?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&subjects=" +
          encodeURIComponent(this.subjectObj.subject.trim()) +
          "&userID=" +
          this.$store.state.userData.userID,
        body: {
          id: 0,
          subject: this.subjectObj.subject.trim(),
          campusID: this.$store.state.userData.cId,
          isOptional: false,
          school: null,
        },
        message: this.$t("Subject added successfully."),
        context: this,
        token: this.$store.state.userData.token,
      });
      this.savingSubject = false;
      if (status) {
        this.subjectObj.subject = "";
        await this.getSubjects();
      }
    },
    async loadDropdownList(category) {
      var obj = {
        url:
          this.$store.state.domain +
          "DropdownList/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&category=" +
          category,
        token: this.$store.state.userData.token,
      };
      const res = await this.get(obj);
      return Array.isArray(res) ? res : [];
    },
    async openDropdownModal(category) {
      this.dropdownModalCategory = category;
      this.dropdownModalTitle =
        category === "ageCategory"
          ? this.$t("Manage Age Categories")
          : this.$t("Manage Empower Levels");
      this.dropdownModalVisible = true;
      this.dropdownFormTitle = "";
      this.dropdownModalSearch = "";
      this.dropdownEditingId = null;
      this.dropdownEditingTitle = "";
      await this.refreshDropdownModalItems();
    },
    closeDropdownModal() {
      this.dropdownModalVisible = false;
      this.dropdownModalCategory = "";
      this.dropdownFormTitle = "";
      this.dropdownModalSearch = "";
      this.dropdownEditingId = null;
      this.dropdownEditingTitle = "";
    },
    startEditDropdownItem(item) {
      this.dropdownEditingId = item.id;
      this.dropdownEditingTitle = item.title;
    },
    cancelEditDropdownItem() {
      this.dropdownEditingId = null;
      this.dropdownEditingTitle = "";
    },
    async refreshDropdownModalItems() {
      if (!this.dropdownModalCategory) return;
      this.dropdownLoading = true;
      this.dropdownModalItems = await this.loadDropdownList(
        this.dropdownModalCategory
      );
      this.dropdownLoading = false;
    },
    async saveDropdownItem() {
      if (this.dropdownFormTitle.trim() === "") {
        return this.$bvToast.toast(this.$t("Please enter a name."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
      }
      await this.postDropdownSave(0, this.dropdownFormTitle.trim());
    },
    async saveDropdownEdit() {
      if (this.dropdownEditingTitle.trim() === "") {
        return this.$bvToast.toast(this.$t("Please enter a name."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
      }
      const status = await this.postDropdownSave(
        this.dropdownEditingId,
        this.dropdownEditingTitle.trim()
      );
      if (status) {
        this.cancelEditDropdownItem();
      }
    },
    async postDropdownSave(id, title) {
      this.dropdownSaving = true;
      var status = await this.post({
        url:
          this.$store.state.domain +
          "DropdownList/Save?db=" +
          this.$store.state.userData.db,
        body: {
          id: id || 0,
          title: title,
          typee: this.dropdownModalCategory,
          campusID: this.$store.state.userData.cId,
        },
        message: this.$t(id ? "Updated successfully." : "Added successfully."),
        context: this,
        token: this.$store.state.userData.token,
      });
      this.dropdownSaving = false;
      if (status) {
        this.dropdownFormTitle = "";
        await this.refreshDropdownModalItems();
      }
      return status;
    },
    async getSessionsList() {
      this.loadingSessionsList = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Sessions?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      const res = await this.get(obj);
      if (Array.isArray(res)) {
        this.sessionsList = res.filter(
          (el) => el.session != null && el.session != ""
        );
      } else {
        this.sessionsList = [];
      }
      this.sessions = this.sessionsList;
      this.loadingSessionsList = false;
    },
    async openSessionsManageModal() {
      this.sessionsModalManageVisible = true;
      this.editingSessionManageId = null;
      this.editingSessionManageName = "";
      this.editingSessionManageObj = null;
      this.sessionModalSearch = "";
      this.sessionManageObj.session = "";
      this.loadingSessionsList = true;
      await this.getSessionsList();
      this.loadingSessionsList = false;
    },
    closeSessionsManageModal() {
      this.sessionsModalManageVisible = false;
      this.editingSessionManageId = null;
      this.editingSessionManageName = "";
      this.editingSessionManageObj = null;
      this.sessionModalSearch = "";
      this.sessionManageObj.session = "";
    },
    startEditSessionManage(sess) {
      this.editingSessionManageId = sess.id;
      this.editingSessionManageName = sess.session;
      this.editingSessionManageObj = { ...sess };
    },
    cancelEditSessionManage() {
      this.editingSessionManageId = null;
      this.editingSessionManageName = "";
      this.editingSessionManageObj = null;
    },
    async saveSessionManageEdit() {
      if (
        !this.editingSessionManageName ||
        this.editingSessionManageName.trim() == ""
      ) {
        return this.$bvToast.toast(
          "Please enter the " + this.sessionLabel.toLowerCase() + " name.",
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-right",
          }
        );
      }
      this.savingSessionManageEdit = true;
      const currentObj =
        this.editingSessionManageObj ||
        this.sessionsList.find((s) => s.id === this.editingSessionManageId) ||
        {};
      var status = await this.put({
        url:
          this.$store.state.domain +
          "Sessions/" +
          this.editingSessionManageId +
          "?db=" +
          this.$store.state.userData.db,
        body: {
          ...currentObj,
          session: this.editingSessionManageName.trim(),
        },
        message: this.$t(this.sessionLabel + " updated successfully."),
        context: this,
        token: this.$store.state.userData.token,
      });
      this.savingSessionManageEdit = false;
      if (status) {
        this.cancelEditSessionManage();
        await this.getSessionsList();
      }
    },
    async postSessionManage() {
      if (
        !this.sessionManageObj.session ||
        this.sessionManageObj.session.trim() == ""
      ) {
        return this.$bvToast.toast(
          "Please enter the " + this.sessionLabel.toLowerCase() + " name.",
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-right",
          }
        );
      }
      this.savingSessionManage = true;
      var status = await this.post({
        url:
          this.$store.state.domain +
          "Sessions?db=" +
          this.$store.state.userData.db,
        body: {
          id: 0,
          session: this.sessionManageObj.session.trim(),
          campusID: this.$store.state.userData.cId,
          isCurrentSession: false,
          status: "",
        },
        message: this.$t(this.sessionLabel + " added successfully."),
        context: this,
        token: this.$store.state.userData.token,
      });
      this.savingSessionManage = false;
      if (status) {
        this.sessionManageObj.session = "";
        await this.getSessionsList();
      }
    },
    async markSessionActive(id) {
      this.markingActiveSessionId = id;
      var status = await this.post({
        url:
          this.$store.state.domain +
          "Sessions/MarkActive?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&sessionID=" +
          id,
        body: null,
        message: this.$t(this.sessionLabel + " marked as active successfully."),
        context: this,
        token: this.$store.state.userData.token,
      });
      this.markingActiveSessionId = null;
      if (status) {
        await this.getSessionsList();
      }
    },
    async LoadSessions() {
      await this.getSessionsList();
    },
    async openSectionsModal() {
      this.sectionsModalVisible = true;
      this.editingSectionId = null;
      this.editingSectionName = "";
      this.editingSectionObj = null;
      this.sectionModalSearch = "";
      this.sectionObj.section = "";
      this.loadingSections = true;
      await this.getSections();
      this.loadingSections = false;
    },
    closeSectionsModal() {
      this.sectionsModalVisible = false;
      this.editingSectionId = null;
      this.editingSectionName = "";
      this.editingSectionObj = null;
      this.sectionModalSearch = "";
      this.sectionObj.section = "";
    },
    startEditSection(sec) {
      this.editingSectionId = sec.id;
      this.editingSectionName = sec.section;
      this.editingSectionObj = { ...sec };
    },
    cancelEditSection() {
      this.editingSectionId = null;
      this.editingSectionName = "";
      this.editingSectionObj = null;
    },
    async saveSectionEdit() {
      if (this.editingSectionName.trim() == "") {
        return this.$bvToast.toast(
          "Please enter the " + this.sectionLabel + " name.",
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-right",
          }
        );
      }
      this.savingSectionEdit = true;
      const currentObj =
        this.editingSectionObj ||
        this.sections.find((s) => s.id === this.editingSectionId) ||
        {};
      var status = await this.put({
        url:
          this.$store.state.domain +
          "Sections/" +
          this.editingSectionId +
          "?db=" +
          this.$store.state.userData.db,
        body: {
          ...currentObj,
          section: this.editingSectionName.trim(),
        },
        message: this.$t(this.sectionLabel + " updated successfully."),
        context: this,
        token: this.$store.state.userData.token,
      });
      this.savingSectionEdit = false;
      if (status) {
        this.cancelEditSection();
        await this.getSections();
        this.LoadClasses(this.current);
      }
    },
    addSection() {
      this.selecting = false;
      this.sectionObj.section = "";
      // console.log("secObj:", this.sectionObj);
    },
    async postSection() {
      // console.log("secObj", this.sectionObj);
      if (this.sectionObj.section.trim() == "") {
        return this.$bvToast.toast(
          "Please enter the " + this.sectionLabel + " name.",
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-right",
          }
        );
      } else {
        this.savingSection = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Sections?db=" +
            this.$store.state.userData.db,
          body: this.sectionObj,
          message: this.$t(this.sectionLabel + " added successfully."),
          context: this,
          token: this.$store.state.userData.token,
        });
        this.savingSection = false;
        if (status) {
          this.selecting = true;
          this.sectionObj.section = "";
          this.getSections();
        }
      }
    },
    HideSection() {
      this.selecting = true;
      this.sectionObj.section = "";
    },
    selectSection(id) {
      // console.log(id);
      if (this.allSectionIDs.includes(id)) {
        this.allSectionIDs = this.allSectionIDs.filter((el) => el != id);
      } else {
        this.allSectionIDs.push(id);
      }
      // console.log("sec_ids", this.allSectionIDs);
      this.CheckSections();
    },
    CheckRequired(name) {
      var elem = this.$refs[name];
      if (this.myObj.name == "" || this.myObj.name > 20) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }

      // return (elem.state = this.$v.depObj.name.required);
    },

    CheckName() {
      var elem = this.$refs["name"];
      if (this.myObj.cls.name == "" || this.myObj.cls.name > 20) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDepName() {
      var elem = this.$refs["depname"];
      if (this.depObj.name == "" || this.depObj.name == null) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDepartment() {
      var elem = this.$refs["department"];
      if (this.myObj.cls.departmentID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckSections() {
      var elem = this.$refs["sections"];
      if (this.allSectionIDs.length == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    hideSideBar() {
      this.visibility = false;
      this.allSectionIDs = [];
    },
    hideDepSideBar() {
      this.visibility1 = false;
    },

    Form() {
      this.$router.push("/apps/schoolinfo");
    },

    checkTitle() {
      var elem = this.$refs["title"];
      return (elem.state = this.myObj.name.length > 2 ? true : false);
    },

    async LoadDepartments() {
      var obj = {
        url:
          this.$store.state.domain +
          "departments?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.myDepartments = await this.get(obj);
    },

    async LoadClasses(dID) {
      this.current = dID;
      this.gridLoading = true;

      let obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClassesAll?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&dID=" +
          dID,
        token: this.$store.state.userData.token,
      };
      // if (this.reportDomain == "myskoolhpgs") {
      //   obj = {
      //     url:
      //       this.$store.state.domain +
      //       "myclasses/LoadClassesAll?db=" +
      //       this.$store.state.userData.db +
      //       "&cId=" +
      //       this.$store.state.userData.cId +
      //       "&dID=" +
      //       dID,
      //     token: this.$store.state.userData.token,
      //   };
      // }

      this.items = await this.get(obj);

      // Sort items by sequence to display in correct order
      this.items.sort((a, b) => {
        const sequenceA = a.cls.sequence || 0;
        const sequenceB = b.cls.sequence || 0;
        return sequenceA - sequenceB;
      });

      if (dID == 0) {
        this.allClasses = [];
        this.items.forEach((el) => {
          this.allClasses.push(el.cls);
        });
      }
      // console.log("classes", this.items);
      // this.items = [];

      if (this.items.length != 0) {
        this.totalRows = this.items.length;
      }
      this.gridLoading = false;
    },

    async DepAdd() {
      this.CheckDepName();
      if (this.CheckDepName() == false) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        if (this.depObj.id == 0) {
          //Add
          this.request = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "departments?db=" +
              this.$store.state.userData.db,
            body: this.depObj,
            message: "Department added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          this.visibility1 = false;
          if (status) this.LoadDepartments();
        } else {
          //Edit
          this.request = true;
          var status = await this.put({
            url:
              this.$store.state.domain +
              "departments/" +
              this.depObj.id +
              "?db=" +
              this.$store.state.userData.db,
            body: this.depObj,
            message: "Department updated successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) {
            this.visibility1 = false;
            this.LoadDepartments();
          }
        }
      }
    },

    async DeleteDep(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "departments/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          message: "Department removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadDepartments();
      }
    },

    async Add() {
      // console.log("classObj", this.myObj);
      this.CheckName();
      this.CheckDepartment();
      this.CheckSections();
      if (
        this.CheckName() == false ||
        this.CheckDepartment() == false ||
        this.CheckSections() == false
      ) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        // this.myObj.sections = this.myObj.sections.toString();
        this.myObj.sectionIDs = this.allSectionIDs;
        if (this.myObj.cls.startsAt == "") this.myObj.cls.startsAt = null;

        if (this.myObj.cls.id == 0) {
          //Add
          this.request = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "myclasses/Add?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: this.$t(this.classLabel + " added successfully."),
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          this.visibility = false;
          if (status) {
            this.LoadClasses(0);

            setTimeout(() => {
              this.showPopup();
            }, 1000);
          }
        } else {
          //Edit
          this.request = true;
          var status = await this.put({
            url:
              this.$store.state.domain +
              "myclasses/Edit?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: this.$t(this.classLabel + " updated successfully."),
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          this.visibility = false;
          if (status) this.LoadClasses(0);
        }
      }
    },
    async Assign() {
      if (this.CheckSections() == false) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.request = true;
        this.myObj.sectionIDs = this.allSectionIDs;
        if (this.myObj.cls.startsAt == "") this.myObj.cls.startsAt = null;

        var status = await this.put({
          url:
            this.$store.state.domain +
            "myclasses/Edit?db=" +
            this.$store.state.userData.db,
          body: this.myObj,
          message: this.$t(this.classLabel + " updated successfully."),
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        this.secVisibility = false;
        if (status) this.LoadClasses(0);
      }
    },
    async showPopup() {
      // fee rights and settings to show popup
      let feeRights = this.$store.state.rights["manage-fee"];
      if (
        this.feePopup &&
        this.feePopup.valueBool &&
        feeRights &&
        feeRights.add
      ) {
        let result = await Swal.fire({
          title: "Update Fee Structure",
          text: "Do you want to update the fee structure for new class?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("Yes"),
        });
        if (result.isConfirmed) {
          this.$router.push({ name: "manage-fee" });
        }
      }
    },

    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "myclasses/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          message: this.$t(this.classLabel + " removed successfully."),
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadClasses(0);
      }
    },

    async leftClass(id, text) {
      let st = text ? text : "left";
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        html: `Do you want to mark whole ${this.classLabel} as <span class="font-weight-bolder text-uppercase text-danger">${st}</span>.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("Yes"),
      });

      if (result.isConfirmed) {
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Students/LeftWholeClass?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&classID=" +
            id +
            "&status=" +
            text,
          body: null,
          message: this.$t(this.classLabel + " marked as " + st),
          context: this,
          token: this.$store.state.userData.token,
        });
        // if (status) this.LoadClasses();
      }
    },
    async leftNew() {
      if (this.isCoaching && this.leftSessionID == 0) {
        return this.$bvToast.toast("Please select the session", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        html: `Do you want to mark whole ${this.classLabel} as <span class="font-weight-bolder text-uppercase text-danger">Left</span>.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("Yes"),
      });

      if (result.isConfirmed) {
        this.lefting = true;
        let st = this.leftSelected == "None" ? "" : this.leftSelected;
        let params = "";
        if (this.isCoaching) {
          params = "&sessionID=" + this.leftSessionID;
        }

        var status = await this.post({
          url:
            this.$store.state.domain +
            "Students/LeftWholeClassNew?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&classID=" +
            this.leftCls +
            "&status=" +
            st +
            params,
          body: null,
          message: this.$t(this.classLabel + " marked as left."),
          context: this,
          token: this.$store.state.userData.token,
        });
        this.lefting = false;
        if (status) this.visibility8 = false;
      }
    },
    async changeStatus(cls, newStatus) {
      const result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: `Do you want to ${newStatus ? "activate" : "deactivate"} this ${
          this.classLabel
        }?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      });

      if (result.isConfirmed) {
        let cObj = { ...cls };
        cObj.status = newStatus ? "active" : "inactive";
        const obj = {
          url:
            this.$store.state.domain +
            "myclasses/" +
            cls.id +
            "?db=" +
            this.$store.state.userData.db,
          body: cObj,
          token: this.$store.state.userData.token,
          message: `${this.classLabel} is now ${
            newStatus ? "active" : "inactive"
          } successfully!`,
          context: this,
        };

        const status = await this.put(obj);
        if (status) {
          cls.status = cObj.status;
          this.$bvToast.toast(
            `${this.classLabel} ${
              newStatus ? "activated" : "deactivated"
            } successfully!`,
            {
              title: this.$t("Success"),
              variant: "success",
              toaster: "b-toaster-top-right",
            }
          );
        } else {
          // Revert the toggle if API call fails
          cls.status = newStatus ? "inactive" : "active";
        }
      } else {
        // Revert the toggle if user cancels
        cls.status = newStatus ? "inactive" : "active";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

#modal-sections___BV_modal_outer_ .modal-backdrop,
body > #modal-sections___BV_modal_outer_ .modal-backdrop,
#modal-subjects___BV_modal_outer_ .modal-backdrop,
body > #modal-subjects___BV_modal_outer_ .modal-backdrop,
#modal-happiness-dropdown___BV_modal_outer_ .modal-backdrop,
body > #modal-happiness-dropdown___BV_modal_outer_ .modal-backdrop,
#modal-sessions-manage___BV_modal_outer_ .modal-backdrop,
body > #modal-sessions-manage___BV_modal_outer_ .modal-backdrop {
  opacity: 1 !important;
  background: rgba(0, 0, 0, 0.25) !important;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.sections-modal-wrapper {
  .modal-dialog {
    max-width: 560px;
    box-shadow: none !important;
    filter: none !important;
  }

  .sections-modal-content {
    border: 1px solid rgba(115, 103, 240, 0.12);
    border-radius: 16px;
    box-shadow: none !important;
    max-height: 90vh;
    overflow: hidden;
  }

  .sections-modal-header {
    background: linear-gradient(
      135deg,
      rgba(115, 103, 240, 0.1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
    border-bottom: 1px solid rgba(115, 103, 240, 0.1);
    padding: 1.15rem 3.25rem 1.15rem 1.35rem;
    border-radius: 16px 16px 0 0;
    position: relative;
    overflow: visible;

    .close {
      position: absolute;
      top: 0;
      right: 0;
      margin: 0;
      padding: 0;
      width: 46px;
      height: 46px;
      opacity: 1;
      text-shadow: none;
      float: none;
      border: none;
      border-radius: 0 16px 0 14px;
      background: #7367f0;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.35rem;
      font-weight: 400;
      line-height: 1;
      transition: transform 0.2s ease, background 0.2s ease, color 0.2s ease;

      span {
        line-height: 1;
      }

      &:hover,
      &:focus {
        opacity: 1;
        outline: none;
        background: #6254e8;
        color: #fff;
        transform: scale(1.08);
      }

      &:active {
        transform: scale(1.02);
        background: #574bd6;
      }
    }
  }

  .sections-modal-title {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    h5 {
      font-weight: 600;
      color: #4b465c;
      font-size: 1.05rem;
    }
  }

  .sections-modal-title-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
    color: #fff;
    box-shadow: 0 4px 12px rgba(115, 103, 240, 0.35);
    flex-shrink: 0;
  }

  .sections-modal-subtitle {
    color: #a8aaae;
    font-size: 0.78rem;
  }

  .sections-modal-body {
    padding: 1.15rem 1.35rem 1.35rem;
    background: #f8f7fc;
    overflow: hidden;
  }

  .sections-modal-add-panel {
    display: flex;
    gap: 0.65rem;
    padding: 0.85rem;
    background: #fff;
    border: 1px solid rgba(115, 103, 240, 0.1);
    border-radius: 12px;
    margin-bottom: 0.85rem;
    box-shadow: 0 2px 8px rgba(115, 103, 240, 0.04);
  }

  .sections-modal-input {
    border-radius: 10px;
    border-color: #e4e1f0;
    background: #fff;
    font-size: 0.9rem;

    &:focus {
      border-color: rgba(115, 103, 240, 0.45);
      box-shadow: 0 0 0 0.15rem rgba(115, 103, 240, 0.12);
    }
  }

  .sections-modal-add-btn {
    border-radius: 10px;
    padding-left: 1rem;
    padding-right: 1rem;
    white-space: nowrap;
    box-shadow: 0 4px 12px rgba(115, 103, 240, 0.25);
  }

  .sections-modal-search {
    position: relative;
    margin-bottom: 0.85rem;
  }

  .sections-modal-search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #b9b9c3;
    z-index: 2;
    pointer-events: none;
  }

  .sections-modal-search-input {
    padding-left: 2.25rem;
    background: #fff;
    border-color: #ebe9f1;
  }

  .sections-modal-table-wrap {
    max-height: 50vh;
    overflow-y: auto;
    background: #fff;
    border: 1px solid rgba(115, 103, 240, 0.1);
    border-radius: 12px;
    scrollbar-width: thin;
    scrollbar-color: rgba(115, 103, 240, 0.28) transparent;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      margin: 6px 0;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(115, 103, 240, 0.22);
      border-radius: 999px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(115, 103, 240, 0.4);
    }

    table {
      margin-bottom: 0;
    }

    .table thead th {
      position: sticky;
      top: 0;
      z-index: 1;
      background: #f3f2f8;
      border-bottom: 1px solid rgba(115, 103, 240, 0.08);
      color: #6e6b7b;
      font-size: 0.72rem;
      font-weight: 600;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      padding: 0.75rem 1rem;
    }

    .table tbody td {
      padding: 0.65rem 1rem;
      border-color: #f1f0f5;
      color: #4b465c;
      font-size: 0.9rem;
      vertical-align: middle;
    }

    .table-hover tbody tr:hover {
      background: rgba(115, 103, 240, 0.04);
    }
  }
}
</style>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}

.card {
  transition: 0.4s;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

/* .sectionBadge {
  margin-inline: 5px;
  margin-top: 5px;
  margin-bottom: 3px;
  padding: 10px;
  border: 2px solid var(--primary);
  color: var(--primary);
  background-color: white;
  cursor: pointer;
} */

/* Drag and Drop Styles */
.cursor-move {
  cursor: move !important;
}

.sortable-ghost {
  opacity: 0.5;
  background: #f8f9fa !important;
}

.sortable-chosen {
  background: #e3f2fd !important;
}

.sortable-drag {
  background: #ffffff !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
  transform: rotate(5deg);
}

.drag-handle:hover {
  color: #007bff !important;
  transform: scale(1.1);
  transition: all 0.2s ease;
}

/* Status Toggle Styles */
.status-toggle {
  transform: scale(1.3);
  /* margin: 8px 0; */
}

.status-toggle .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #28a745;
  border-color: #28a745;
}

.status-toggle
  .custom-control-input:not(:checked)
  ~ .custom-control-label::before {
  background-color: #dc3545;
  border-color: #dc3545;
}

.status-toggle .custom-control-label::before {
  width: 3rem;
  height: 1.5rem;
  border-radius: 1rem;
}

.status-toggle .custom-control-label::after {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  top: 0.125rem;
  left: 0.125rem;
}

.status-toggle .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(1.5rem);
}

.status-badge {
  font-size: 0.875rem;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-weight: 600;
}
</style>
